<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14 2.33334L7.58331 12.8333H20.4166L14 2.33334Z" fill="#495057" />
    <path
      d="M20.4167 25.6667C23.3162 25.6667 25.6667 23.3162 25.6667 20.4167C25.6667 17.5172 23.3162 15.1667 20.4167 15.1667C17.5172 15.1667 15.1667 17.5172 15.1667 20.4167C15.1667 23.3162 17.5172 25.6667 20.4167 25.6667Z"
      fill="#495057"
    />
    <path d="M3.5 15.75H12.8333V25.0833H3.5V15.75Z" fill="#495057" />
  </svg>
</template>

<script>
export default {
  name: 'IconCategory',
  props: {
    width: {
      type: Number,
      default: 23,
    },
    height: {
      type: Number,
      default: 23,
    },
  },
};
</script>

<style scoped>
</style>